module.exports = require('./_global');


//////////////////
// WEBPACK FOOTER
// /Users/luca/dev/lucagarbin/mascioni.it/~/core-js/modules/_path.js
// module id = 146
// module chunks = 0